import {
  centsToDollars,
  handleInputChange,
  titleCase,
} from "legacy/helpers.es6"
import RefundForCancel from "legacy/manage/cancel/RefundForCancel"
import { validatorFactory } from "legacy/validatorFactory"
import PropTypes from "prop-types"
import React from "react"

import Modal from "src/components/Modal"

class RefundModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loadingBalance: true,
      errorLoadingBalance: null,
      showModal: false,
      currentBalance: 0,
      refundPrice: 0,
      currentPrice: this.props.currentPrice,
    }
    this.handleInputChange = this.handleInputChange.bind(this)
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.fetchBalance = this.fetchBalance.bind(this)
    this.adjustmentDidUpdate = this.adjustmentDidUpdate.bind(this)
    this.submit = this.submit.bind(this)
    this.validator = validatorFactory()
    this.refundForCancel = null
    this.setRefundForCancelRef = (element) => {
      this.refundForCancel = element
    }
    this.btnTitle = `Cancel ${titleCase(this.props.resourceName)}`
  }

  handleInputChange(event) {
    handleInputChange(this, event)
  }

  openModal() {
    this.setState({
      showModal: true,
      loadingBalance: true,
      submitErrorMessage: null,
    })
    this.fetchBalance()
  }

  closeModal() {
    this.setState({ showModal: false })
  }

  fetchBalance() {
    $.get(this.props.balanceUrl, (data) => {
      this.setState({
        errorLoadingBalance: null,
        loadingBalance: false,
        currentBalance: data.balance,
        refundPrice: data.balance,
      })
    }).fail((data) => {
      this.setState({
        loadingBalance: false,
        errorLoadingBalance: data.responseJSON.error,
      })
    })
  }

  submit() {
    this.validator.showMessages()
    if (this.validator.allValid()) {
      this.setState({
        processing: true,
        submitErrorMessage: null,
      })
      const params = { lock_version: this.props.lockVersion }
      const state = this.refundForCancel.state
      if (state.adjustmentAmount > 0) {
        params.adjustment_amount = state.adjustmentAmount
        params.adjustment_description = state.adjustmentDescription
      }
      $.patch(this.props.endpoint, params, () => {
        location.reload()
      }).fail((data) => {
        const errorMessage = data.responseJSON
          ? data.responseJSON.error
          : "Something went wrong while trying to cancel the reservation. Please try again or contact support."
        this.setState({
          processing: false,
          submitErrorMessage: errorMessage,
        })
      })
    } else {
      this.validator.showMessages()
      this.forceUpdate()
    }
  }

  adjustmentDidUpdate(adjustmentAmount) {
    this.setState({ refundPrice: this.state.currentBalance - adjustmentAmount })
  }

  footerLink() {
    return (
      <div className="bs-mt-2 float-left">
        View marina&apos;s{" "}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={this.props.cancellationPolicyUrl}
        >
          Cancellation Policy
        </a>
      </div>
    )
  }

  renderRefundAmount() {
    if (this.state.loadingBalance) {
      return <span>Loading...</span>
    } else if (this.state.errorLoadingBalance) {
      return <span>{this.state.errorLoadingBalance}</span>
    } else {
      return (
        <span className="h3 font-semibold">
          {centsToDollars(this.state.refundPrice)}
        </span>
      )
    }
  }

  render() {
    return (
      <div>
        <button
          className={`btn btn-reservation-action ${this.props.btnClass}`}
          onClick={this.openModal}
          type="button"
        >
          {this.btnTitle}
        </button>
        <Modal
          isOpen={this.state.showModal}
          onClose={this.closeModal}
          size="mediumFixed"
        >
          <Modal.Header title={this.btnTitle} />
          <Modal.Body>
            {this.props.cancellationReason ? (
              <div className="alert alert-blue bs-mb-4">
                <strong>Boater Cancellation Reason:</strong>{" "}
                {this.props.cancellationReason}
              </div>
            ) : null}
            <div className="row bs-mt-4">
              <div className="col-xs-offset-3 col-xs-6">
                <div className="bg-gray bs-p-4 rounded text-center text-teal-700">
                  <div className="text-black">Refund Amount</div>
                  {this.renderRefundAmount()}
                </div>
              </div>
            </div>
            <RefundForCancel
              ref={this.setRefundForCancelRef}
              currentPrice={this.props.currentPrice}
              boaterCancel={this.props.boaterCancel}
              validator={this.validator}
              adjustmentDidUpdate={this.adjustmentDidUpdate}
              resourceName={this.props.resourceName}
            />
            {this.state.submitErrorMessage ? (
              <div className="text-danger bs-mt-3">
                {this.state.submitErrorMessage}
              </div>
            ) : null}
          </Modal.Body>
          <Modal.Footer>
            <div className="flex w-full items-center justify-between">
              {this.props.cancellationPolicyUrl && (
                <div className="flex-1 text-left">
                  View marina&apos;s{" "}
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={this.props.cancellationPolicyUrl}
                  >
                    Cancellation Policy
                  </a>
                </div>
              )}
              <div className="flex gap-2">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={this.closeModal}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={this.submit}
                  disabled={this.state.processing}
                >
                  {this.state.processing ? (
                    <>
                      <span
                        className="fa-kit fa-spin fa-spinner mr-2"
                        aria-label="loading indicator"
                        aria-hidden="true"
                      />
                      {this.btnTitle}
                    </>
                  ) : (
                    this.btnTitle
                  )}
                </button>
              </div>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}

RefundModal.propTypes = {
  balanceUrl: PropTypes.string.isRequired,
  boaterCancel: PropTypes.bool,
  btnClass: PropTypes.string,
  cancellationPolicyUrl: PropTypes.string,
  cancellationReason: PropTypes.string,
  currentPrice: PropTypes.number,
  endpoint: PropTypes.string.isRequired,
  lockVersion: PropTypes.number,
  resourceName: PropTypes.string.isRequired,
}

export default RefundModal
